<div class="close-button">
  <button tabIndex="-1" class="" mat-icon-button (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<h1 mat-dialog-title>
  {{
    data.title ? (data.title | translate) : ('moveToFolderTitle' | translate)
  }}
</h1>
<mat-dialog-content
  class="mat-mdc-dialog-content mdc-dialog__content mat-container">
  @if (isLoading) {
    <div>
      <ngx-skeleton-loader
        [count]="1"
        [theme]="{
          'margin-bottom': 0,
          height: '74px',
          width: '100%',
        }"></ngx-skeleton-loader>
    </div>
  }

  @if (cannotLoad) {
    <div>
      <app-something-went-wrong
        [showPicture]="false"
        description="{{ 'cannotLoadDataError' | translate }}"
        (retryEmitter)="loadFolders()">
      </app-something-went-wrong>
    </div>
  }

  @if (!isLoading && !cannotLoad) {
    <div>
      @if (folderOptions.length) {
        <app-searchable-select
          [label]="'folder' | translate"
          [items]="folderOptions"
          [(ngModel)]="selectedFolderId" />
      }
      @if (cannotSave) {
        <app-error-hint
          errorText="{{ errorText | translate }}"
          [centerAlign]="false"></app-error-hint>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions
  align="end"
  class="mat-mdc-dialog-actions mdc-dialog__actions">
  <button
    mat-button
    mat-flat-button
    color="primary"
    (click)="confirm()"
    [disabled]="moveInProgress || isLoading || cannotLoad || !selectedFolderId">
    <app-loading-button
      text="{{ 'move' | translate }}"
      [loading]="moveInProgress"></app-loading-button>
  </button>
</mat-dialog-actions>
